// removed by extract-text-webpack-plugin
module.exports = {"component":"QjnMq6NjI60AYEXXGK346","content":"_3aF6ah4zNpuaofMcXvQGuy","header":"_2FQgbYANgAYahrRzDVLyeG","orderStatus":"_2S84MfGdl_bAN51p7ahCgq","wholeLine":"_2jvRTdhoaH_jMxXuZNZYaN","leftLine":"K3Zw2CYb902xd-LJ7MVr4","rightLine":"_3CFMHreBL7n5d7Ke_TSYht","contentSection":"_2P4qG22Y59VXF5ecgq3rmq","pageTopTitle":"_3zBI9xaq93DcFzkYClsMfB","item":"_3AV9zSQGUJPzq4PV6FOu_8","bottomBtn":"NRQ8Hj_kaW6GVsoLfknca"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/GroupBuyingOrderDetailComponent/GroupBuyingOrderDetailComponent.scss
 ** module id = 977
 ** module chunks = 0
 **/